import { coresMescladasArray } from '../../../../Common/styles/colors';
import { useAttentionChartsDataContext } from './useAttentionChartsDataContext';

const useTypesOfBirthMothersAge = () => {
    const { chartData } = useAttentionChartsDataContext();

    const categories = chartData.typesOfBirthMothersAge.map(
        (item) => item.description
    );

    const subtitles = ['Cesáreo', 'Vaginal', 'Ignorado'];

    const totalPerCategory = categories.map((category) => {
        const found = chartData.typesOfBirthMothersAge
            .filter((counter) => counter.description === category)
            .reduce((acc, curr) => {
                const total =
                    Number(curr.cesarean) +
                    Number(curr.vaginal) +
                    Number(curr.ignored);
                return acc + total;
            }, 0);

        return found ? Number(found) : 0;
    });

    const series = subtitles.map((subtitle) => {
        const data = categories.map((category, index) => {
            if (totalPerCategory[index] === 0) {
                return 0;
            }

            const found = chartData.typesOfBirthMothersAge.find(
                (counter) => counter.description === category
            );

            let value = 0;

            switch (subtitle) {
                case 'Cesáreo':
                    value = found.cesarean;
                    break;
                case 'Vaginal':
                    value = found.vaginal;
                    break;
                case 'Ignorado':
                    value = found.ignored;
                    break;
                default:
                    value = 0;
                    break;
            }

            return found
                ? ((Number(value) / totalPerCategory[index]) * 100).toFixed(2)
                : 0;
        });

        return {
            name: subtitle,
            data
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'bar',
                height: 400,
                stacked: true,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    borderRadius: 4,
                    borderRadiusApplication: 'end',
                    borderRadiusWhenStacked: 'last'
                }
            },
            yaxis: {
                max: 100
            },
            xaxis: {
                categories: categories || [],
                labels: {
                    formatter: (val) => `${val}%`
                }
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            fill: {
                opacity: 1
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val}%`,
                style: {
                    colors: ['#ffffff'],
                    fontSize: '11px'
                }
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Arial, sans-serif',
                    padding: '10px',
                    pointerEvents: 'auto',
                    zIndex: '1000'
                },
                y: {
                    formatter: (val) => (val ? `${val.toLocaleString('pt-BR')}%` : '')
                }
            },
            grid: {
                show: false
            },
            colors: coresMescladasArray
        }
    };

    return {
        chartConfig
    };
};

export default useTypesOfBirthMothersAge;
